import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { useHotjar } from 'app/shared/utils';
import { Box, Typography } from 'app/shared/components/atoms';
import { BasePageBox } from 'app/shared/components/molecules';
import { DEFAULT_EVENT_HERO_IMAGE } from 'app/fan/utils/staticImages';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { BasicHero } from 'app/fan/components/molecules';
import { hasEventEnded } from 'app/fan/components/pages/Event/eventUtils';

import { Artists } from './Artists';

export const DoorsOpenPostShowEventPage = () => {
  const intl = useIntl();
  const { event } = useEventPageContext();
  const { sendHotjarStateChange } = useHotjar();
  sendHotjarStateChange('event/past');
  const { colors } = useCurrentTheme();

  if (!event) {
    return null;
  }

  const eventEnded = hasEventEnded(event.startsAt, event.endsAt);

  const isEventDaytime = (event: any): boolean => {
    return new Date(event.startsAt).getHours() < 18;
  };

  const getHeaderText = (event: any): string => {
    if (eventEnded) {
      return intl.formatMessage({
        id: 'event.doorsOpen.whatAShow',
      });
    }

    if (isEventDaytime(event)) {
      return intl.formatMessage({
        id: 'event.doorsOpen.todaysConcert',
      });
    } else {
      return intl.formatMessage({
        id: 'event.doorsOpen.tonightsConcert',
      });
    }
  };

  return (
    <Box
      data-qaid={eventEnded ? 'event-page-post-show' : 'event-page-doors-open'}
    >
      <BasicHero
        backgroundImage={event.landscapeImageUrl || DEFAULT_EVENT_HERO_IMAGE}
        grayscale={eventEnded}
        flexDirection="column"
        gap={2}
        alignItems="center"
        justifyContent="center"
        data-qaid="started-event-hero"
      >
        <Typography
          as="h1"
          data-qaid="started-event-hero-title"
          fontSize="fontSize700"
          color={colors.primary.white.lightest}
          fontFamily="title"
        >
          {getHeaderText(event)}
        </Typography>
        <Typography
          data-qaid="started-event-hero-body"
          fontWeight="medium"
          color={colors.primary.white.lightest}
        >
          {intl.formatMessage({
            id: 'event.doorsOpen.discoverConnectFollow',
          })}
        </Typography>
      </BasicHero>
      <BasePageBox py={8} flexDirection="column" gap={8}>
        <Typography
          as="h2"
          data-qaid="meet-the-artists"
          fontSize="fontSize700"
          color={colors.primary.white.base}
          fontFamily="title"
        >
          {intl.formatMessage({
            id: 'event.doorsOpen.meetTheArtists',
          })}
        </Typography>
        <Artists artists={event.artists} />
      </BasePageBox>
    </Box>
  );
};
